import { Injectable, Injector, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService, UserService } from '../services';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { nrAction } from '../helpers/newrelic.helper';
import { awaitUserLookup, isMemberOrAuthenticated } from './await-user-lookup';

@Injectable({
  providedIn: 'root'
})
export class MemberGuardCanActivate {
  private readonly injector = inject(Injector);

  constructor(private authService: AuthService, private userService: UserService, private router: Router) {
  }

  public canActivate(): Observable<boolean> {
    if (this.authService.getAuthToken() === '') {
      nrAction('guard_blocked', { guard: 'MemberGuard', reason: 'no_token' });
      this.authService.login();
      return of(false)
    }

    return awaitUserLookup(this.userService, this.injector).pipe(
      map(({ user, error }) => {
        if (isMemberOrAuthenticated(user)) {
          return true;
        }
        nrAction('guard_blocked', { guard: 'MemberGuard', reason: error ? 'lookup_failed' : 'not_member' });
        this.router.navigate(['/']);
        return false;
      }));
  }
}

export const MemberGuard: CanActivateFn = () => {
  return inject(MemberGuardCanActivate).canActivate();
};
